import { useMemo } from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { Constants, getCDNOptimizedImage } from '@arrived/common';

import { OfferingName } from '../../../OfferingName';
import { CellBodyTypography } from './CellBodyTypography';

export interface OfferingInfoCellProps {
  className?: string;
  imgSize: number;
  imgUrl: string | null;
  market?: string;
  name: string;
}

export const OfferingInfoCell = ({ className, imgSize, imgUrl, market, name }: OfferingInfoCellProps) => {
  const imageSrc = useMemo(
    () =>
      getCDNOptimizedImage({
        imgUrl: imgUrl ?? Constants.defaultPropertyImageUrl,
        ratio: '1:1',
        width: `${imgSize}px`,
      }),
    [imgSize, imgUrl]
  );

  return (
    <Stack direction="row" gap={2} alignItems="center" className={className}>
      <Box component="img" alt={name} src={imageSrc} width={`${imgSize}px`} borderRadius={1} />
      <div className="offering-info">
        <Typography variant="body1.semibold">
          <OfferingName name={name} />
        </Typography>
        {market && <CellBodyTypography>{market}</CellBodyTypography>}
      </div>
    </Stack>
  );
};
